import { APS_BY_ACTIVITY_CATEGORY_PATH, APPS_BY_ACTIVITY_CATEGORY_PATH } from 'router/types'

export function buildShowApsPath(id = null) {
  return `${APS_BY_ACTIVITY_CATEGORY_PATH}${id}`
}

export function buildShowAppsPath(id = null) {
  return `${APPS_BY_ACTIVITY_CATEGORY_PATH}${id}`
}
